module.exports = __webpack_public_path__ + "04_mustache_brown.48582900.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer3/04_mustache_brown.png
// module id = 8x13
// module chunks = 0